import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { getCookie, setCookie } from 'helpers/Storage';
import Style from './StickyBanner.module.scss';

const withAnchor = (components, url) => {
  if (!url) return null;
  return (
    <a className={Style.wrapper} href={url} target="_blank" rel="noopener noreferrer">
      {components}
    </a>
  );
};
const withDiv = components => <div className={Style.wrapper}>{components}</div>;

const StickyBanner = ({ data = null }) => {
  const [hidden, setHidden] = useState(() => getCookie({ name: cookieName }));
  if (!data) return null;
  const { id = '', headline = '', description = '', url = '' } = data;
  const cookieName = `stickyBanner-${id}`;

  if (hidden) return null;

  const descriptionParts = description ? description.split('\n') : null;

  const onCloseClick = () => {
    setCookie({ name: cookieName, value: true, options: { path: '/' } });
    setHidden(true);
  };

  const titleComponent = headline ? <h1>{headline}</h1> : null;
  const descriptionComponent = descriptionParts
    ? descriptionParts.map(part => <span key={part}>{part}</span>)
    : null;

  const child = [titleComponent, descriptionComponent];

  const wrapperRenderer = url ? withAnchor : withDiv;
  return (
    <div className={Style.stickyBannerContainer}>
      {wrapperRenderer(child, url)}
      <Link className={Style.closeButton} onClick={onCloseClick} />
    </div>
  );
};

StickyBanner.propTypes = {
  data: PropTypes.shape({}),
};

export default StickyBanner;
